import { Navigate, useParams, useSearchParams } from "react-router-dom";
import { legacySettingsTarget } from "./settings-sections";

/**
 * /settings has no content of its own. It opens the company section, or the
 * section an old settings?tab=...&ref=... link meant.
 */
export default function SettingsIndexRedirect() {
  const { companyId } = useParams<{ companyId: string }>();
  const [searchParams] = useSearchParams();
  const { section, search } = legacySettingsTarget(searchParams);

  return (
    <Navigate to={`/app/${companyId}/settings/${section}${search}`} replace />
  );
}
